import React from 'react'
import { SVGIcon } from '~/utils/types'


export const ChevronRight = (props: SVGIcon) => (
  <svg {...props} width="32" height="32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.374 23.607a1.225 1.225 0 01-.059-1.7l.1-.102 6.307-5.713-6.322-5.91a1.225 1.225 0 01-.11-1.699l.098-.104a1.403 1.403 0 011.794-.104l.11.093 7.308 6.831c.503.471.531 1.222.087 1.724l-.102.104-7.308 6.62a1.4 1.4 0 01-1.903-.04z"
      fillRule="evenodd"
    />
  </svg>
)
